import React, { PureComponent } from 'react'
import { Field } from 'redux-form'
import PropTypes from 'prop-types'
import cn from 'classnames'
import './input.scss'
import { pushCheckoutEmailField } from '../../../../helpers/gtm'

class Input extends PureComponent {
  state = {
    mask: Input.defaultProps.mask,
    GTMFlag: true,
  }

  componentDidMount = () => {
    const { value, mask } = this.props
    if (value) {
      this.setState({ mask })
    }
  }

  handleFocus = (e) => {
    const { mask: stateMask } = this.state
    const { mask } = this.props

    if (stateMask !== mask) {
      this.setState({ mask })
    }

    if (Object.prototype.hasOwnProperty.call(mask, 'onFocus') && typeof mask.onFocus === 'function') {
      mask.onFocus(e)
    }
  }

  handleBlur = () => {
    const { mask: stateMask } = this.state
    const { defaultProps: { mask } } = Input
    const { value, name } = this.props

    if ((stateMask !== mask) && !value) {
      this.setState({ mask })
    }


    if (name === 'guestEmail') {
      this.setState({
        GTMFlag: true,
      })
    }
  }

  handleClick = () => {
    const { GTMFlag } = this.state
    const { name } = this.props

    if (GTMFlag && name === 'guestEmail') {
      pushCheckoutEmailField()
      this.setState({
        GTMFlag: false,
      })
    }
  }

  handleClear = () => {

  }

  render() {
    const {
      className,
      type,
      name,
      placeholder,
      value,
      error,
      component,
      active,
      onChange,
      validate,
      readOnly,
      disabled,
      withButton,
      isCsMask,
    } = this.props

    const { mask } = this.state

    const InputField = (
      <Field
        className={cn(`input-control__input inputName-${name}`, placeholder && value && 'input-control__input-value')}
        type={type}
        name={name}
        placeholder={placeholder}
        value={value}
        component={component}
        onChange={onChange}
        onClick={this.handleClick}
        validate={validate}
        autoComplete="off"
        readOnly={readOnly}
        {...mask}
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
        disabled={disabled}
      />
    )

    return (
      <div className={cn('input-control', `wrapper-for-${name}`, className, error && 'input-control__required', withButton && 'input-control--with-button')}>
        <div
          className={cn('input-control__field', className, active && 'active')}
          {...(isCsMask ? { 'data-cs-mask': '' } : {})}>
          {((value || active) && placeholder)
            ? (
              <span className="input-control__label">
                {placeholder}
              </span>
            ) : null
          }
          { withButton
            ? (
              <div className="input-control__wrapper">
                { InputField }
                { withButton.clearButton ? (
                   <span
                     className={cn(withButton.className, active && 'active', value && 'active')}
                     data-rel={withButton.inputName}
                     type="button"
                     onClick={withButton.onClickFunc}
                     role="button"
                   >
                     <span className="x-icon"/>
                   </span>
                ) : (
                  <button
                    className={withButton.className}
                    type="button"
                    onClick={withButton.onClickFunc}
                  >
                    {withButton.btnText}
                  </button>
                )}
              </div>
            ) : (
              InputField
            )}
        </div>
        {error
          ? (
            <div className="input-control__error">
              {error}
            </div>
          ) : null
        }
      </div>
    )
  }
}

Input.propTypes = {
  className: PropTypes.string,
  component: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.string,
  active: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  validate: PropTypes.arrayOf(PropTypes.func),
  mask: PropTypes.objectOf(Object),
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  withButton: PropTypes.oneOfType([
    PropTypes.shape({
      type: PropTypes.string,
    }),
    PropTypes.bool,
  ]),
  isCsMask: PropTypes.bool,
}

Input.defaultProps = {
  value: '',
  error: '',
  className: '',
  type: 'input',
  placeholder: '',
  component: 'input',
  readOnly: false,
  mask: {},
  disabled: false,
  onChange: () => ({}),
  validate: [],
  withButton: false,
  isCsMask: false,
}

export default Input
